export default __webpack_public_path__ + "images/b0d8c36f571ec49f29f059ed7a79dc7b-blog.svg";